import React, { useState } from 'react';
import { contactInfo } from '../data/portfolio';
import './scss/Contact.scss';

interface FormData {
  name: string;
  email: string;
  subject: string;
  message: string;
}

const Contact: React.FC = () => {
  const [formData, setFormData] = useState<FormData>({
    name: '',
    email: '',
    subject: '',
    message: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    // Simulate form submission
    try {
      await new Promise(resolve => setTimeout(resolve, 2000));
      setSubmitStatus('success');
      setFormData({ name: '', email: '', subject: '', message: '' });
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
      setTimeout(() => setSubmitStatus('idle'), 5000);
    }
  };

  const contactItems = [
    // {
    //   icon: 'fas fa-envelope',
    //   label: 'Email',
    //   value: contactInfo.email,
    //   href: `mailto:${contactInfo.email}`
    // },
    // {
    //   icon: 'fas fa-phone',
    //   label: 'Phone',
    //   value: contactInfo.phone,
    //   href: `tel:${contactInfo.phone}`
    // },
    {
      icon: 'fas fa-map-marker-alt',
      label: 'Location',
      value: contactInfo.location,
      href: '#'
    }
  ];

  const socialLinks = [
    {
      icon: 'fab fa-linkedin',
      href: contactInfo.linkedin,
      label: 'LinkedIn'
    },
    {
      icon: 'fab fa-github',
      href: contactInfo.github,
      label: 'GitHub'
    }
  ];

  return (
    <section id="contact" className="contact">
      <div className="container">
        <h2 className="section-title">Get In Touch</h2>
        
        <div className="contact-content">
          <div className="contact-info">
            <h3>Let's Connect</h3>
            <p>
              I'm always open to discussing new opportunities, interesting projects, 
              or just having a chat about technology. Feel free to reach out!
            </p>
            
            <div className="contact-details">
              {contactItems.map((item, index) => (
                <div key={index} className="contact-item">
                  <i className={item.icon}></i>
                  <span>
                    {item.href !== '#' ? (
                      <a href={item.href}>{item.value}</a>
                    ) : (
                      item.value
                    )}
                  </span>
                </div>
              ))}
            </div>
            
            <div className="social-links">
              {socialLinks.map((link, index) => (
                <a
                  key={index}
                  href={link.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-link"
                  aria-label={link.label}
                >
                  <i className={link.icon}></i>
                </a>
              ))}
            </div>
          </div>
          
          {/* <form className="contact-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <input
                type="text"
                name="name"
                placeholder="Your Name"
                value={formData.name}
                onChange={handleInputChange}
                required
              />
            </div>
            
            <div className="form-group">
              <input
                type="email"
                name="email"
                placeholder="Your Email"
                value={formData.email}
                onChange={handleInputChange}
                required
              />
            </div>
            
            <div className="form-group">
              <input
                type="text"
                name="subject"
                placeholder="Subject"
                value={formData.subject}
                onChange={handleInputChange}
                required
              />
            </div>
            
            <div className="form-group">
              <textarea
                name="message"
                placeholder="Your Message"
                rows={5}
                value={formData.message}
                onChange={handleInputChange}
                required
              ></textarea>
            </div>
            
            <button 
              type="submit" 
              className="btn-primary submit-btn"
              disabled={isSubmitting}
            >
              {isSubmitting ? (
                <>
                  <i className="fas fa-spinner fa-spin"></i>
                  Sending...
                </>
              ) : (
                <>
                  <i className="fas fa-paper-plane"></i>
                  Send Message
                </>
              )}
            </button>
            
            {submitStatus === 'success' && (
              <div className="form-status success">
                <i className="fas fa-check-circle"></i>
                Message sent successfully!
              </div>
            )}
            
            {submitStatus === 'error' && (
              <div className="form-status error">
                <i className="fas fa-exclamation-circle"></i>
                Failed to send message. Please try again.
              </div>
            )}
          </form> */}
        </div>
      </div>
    </section>
  );
};

export default Contact;
